import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { scheduleReducer } from 'features/schedule/redux';
import { blockingLoadingReducer } from 'common/blocking-loading';
import { municipalitiesReducer } from 'features/municipalities';
import { organizationsReducer } from 'features/organizations/redux';
import { regionsReducer } from 'features/regions';
import { api } from 'shared/api';
import { educationClassesTableReducer } from 'widgets/education-classes-table';
import { classGroupsTableReducer } from 'widgets/class-groups-table';
import { currentProfileReducer, profileReducer } from '../user-profile';

export const reducer = combineReducers({
  [api.reducerPath]: api.reducer,
  educationClassesTable: educationClassesTableReducer,
  classGroupsTable: classGroupsTableReducer,
  profileState: profileReducer,
  currentProfileState: currentProfileReducer,
  regionsState: regionsReducer,
  municipalitiesState: municipalitiesReducer,
  organizationsState: organizationsReducer,
  blockingLoadingState: blockingLoadingReducer,
  scheduleState: scheduleReducer,
});

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});
